import { MChatInput } from 'graphql/types.generated'
import { isEmpty } from 'lodash'

import {
  convertConsultaSeguimentoQueryToViewModel,
  convertConsultaSeguimentoToInput,
} from './consulta-seguimento/converter-consultaSeguimento'
import { convertMChatQueryToViewModel, convertMChatToPerguntaRespostaInput } from './mchat/converter-mchat'
import { MChatQueryModel } from './mchat/model-mchat'
import { MChatRfFieldModel, MChatRfViewModel } from './model-mChatRf'

export const convertMChatRfToInput = (value: MChatRfFieldModel): MChatInput => {
  if (isEmpty(value)) return null
  return {
    aplicacaoMChatR: convertMChatToPerguntaRespostaInput(value.mchat),
    aplicacaoMChatRf: convertConsultaSeguimentoToInput(value.consultaSeguimento),
  }
}

export const convertMChatRfQueryToViewModel = (
  mChat: MChatQueryModel,
  consultaSeguimento: MChatQueryModel
): MChatRfViewModel => {
  return {
    consultaSeguimento: convertConsultaSeguimentoQueryToViewModel(consultaSeguimento),
    mchat: convertMChatQueryToViewModel(mChat),
  }
}
